var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.75 100.75h-71.5c-7.15 0-13-5.85-13-13v-58.5h97.5v58.5c0 7.15-5.85 13-13 13z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 42.25v-19.5c0-10.725-8.775-19.5-19.5-19.5s-19.5 8.775-19.5 19.5v19.5",
    stroke: "currentColor",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}

var MemoSvgBag = /*#__PURE__*/React.memo(SvgBag);
export default MemoSvgBag;